import { atom } from "recoil";

export const createUserProfileDrawerState = atom({
  key: "createUserProfileDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
